import { render } from "./BaseAddToCart.vue?vue&type=template&id=72ed5ab2&scoped=true"
const script = {}

import "./BaseAddToCart.vue?vue&type=style&index=0&id=72ed5ab2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ed5ab2"]])

export default __exports__